import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { MessageService } from 'src/app/common/services/message.service';
import { ApiService } from 'src/app/common/services/api.service';
import { PHP_API_STATUS } from 'src/app/common/enums/api-status.enum';

@Component({
  selector: 'app-add-voided-item',
  templateUrl: './add-voided-item.component.html',
  styleUrls: ['./add-voided-item.component.css'],
})
export class AddVoidedItemComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  translationText: any;
  unvoidedItemQty: number = 1;
  totalVoidItems: number = 1;

  constructor(
    public _dialogRef: MatDialogRef<AddVoidedItemComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _translateService: TranslateService,
    private _msgService: MessageService,
    private _localStorage: LocalStorageService,
    private _apiService: ApiService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this._translateService.get(['ADD_VOID_DISH']).subscribe((translation) => {
        this.translationText = translation.ADD_VOID_DISH;
      })
    );
    this.totalVoidItems =
      ((this.data || {}).itemDetails || {}).item_quantity || 1;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeModal() {
    this._dialogRef.close({ status: 0, data: null, message: 'closed' });
  }

  modifyUnvoidQty(type: 'increment' | 'decrement') {
    if (type === 'increment') {
      this.unvoidedItemQty++;
    } else if (type === 'decrement') {
      this.unvoidedItemQty--;
    }
  }

  cancelBtnClikced() {
    this.closeModal();
  }

  unvoidDishClicked() {
    const orderItemId =
      ((this.data || {}).itemDetails || {}).order_item_id || '';
    const formData: any = new FormData();
    formData.append('token', this._localStorage.get('token'));
    formData.append('order_item_id', orderItemId);
    formData.append('order_id', (this.data || {}).orderid);
    formData.append('qty', this.unvoidedItemQty);

    this._apiService.addVoidedDish(formData).subscribe((res: any) => {
      try {
        if ((res || {}).status === PHP_API_STATUS.API_SUCCESS) {
          this._msgService.showSuccess((res || {}).message);
        } else {
          this._msgService.showError((res || {}).message);
        }
        this._dialogRef.close({
          status: 1,
          data: null,
          message: 'success',
        });
      } catch (error) {
        this.closeModal();
        this._msgService.showError(((error || {}).error || {}).message);
      }
    });
  }
}
